import React, { useRef } from 'react';

import clsx from 'clsx';

import useScrollIndicator from 'hooks/useScrollIndicator';

/**
 * @param root0
 * @param root0.className
 * @param root0.children
 */
const GlassCardGrid = ({ className, children }) => {
  const scrollRef = useRef(null);
  const { canScrollUp, canScrollDown } = useScrollIndicator(scrollRef);

  return (
    <div className={clsx('glass-card-grid', className)}>
      <div
        className={clsx('glass-card-grid__scroll-indicator', 'glass-card-grid__scroll-indicator--top', {
          'glass-card-grid__scroll-indicator--visible': canScrollUp,
        })}
      />
      <div className="glass-card-grid__inner" ref={scrollRef}>
        {children}
      </div>
      <div
        className={clsx('glass-card-grid__scroll-indicator', 'glass-card-grid__scroll-indicator--bottom', {
          'glass-card-grid__scroll-indicator--visible': canScrollDown,
        })}
      />
    </div>
  );
};

export default GlassCardGrid;
